import { styled } from '@styles/theme'

export const Header = styled('div', {
	width: '100%',
	display: 'grid',
	gridTemplateColumns: 'auto auto max-content',
	alignItems: 'center',
	padding: '23px 0',
	'& p': {
		fontSize: '$xl',
		fontWeight: 400,
		lineHeight: '25px',
		color: '$neutral120',
	},
})

export const Items = styled('div', {
	width: '100%',
	display: 'grid',
	gridTemplateColumns: 'auto auto max-content',
	alignItems: 'center',
	padding: '23px 0',
	borderTop: '1px solid #D9D9D9',
	gap: '0px 10px',
	'& p': {
		fontSize: '$xl',
		fontWeight: 400,
		lineHeight: '25px',
		color: '$neutral120',
	},
})
